/* Froonze injects the product-card wishlist heart (.frcp-wishlist-grid-btn-wrapper)
   only on collection templates. This runs the same pass on every other page that
   shows product cards (home "New Arrivals", search, related products, featured,
   collage) once Froonze has loaded. Cards expose the .card-wrapper class Froonze
   scans for — see snippets/ella-product-card.liquid. Styling: component-wishlist.css. */
(function () {
  function hasProductGrid() {
    var wrappers = document.querySelectorAll('.card-wrapper');
    for (var i = 0; i < wrappers.length; i++) {
      if (wrappers[i].querySelector('a[href*="/products/"]')) return true;
    }
    return false;
  }

  if (!hasProductGrid()) return;

  var tries = 0;
  (function attach() {
    var wishlist = window.frcp && window.frcp.wishlist;
    if (wishlist && wishlist.initialized && typeof wishlist.attachOnCollection === 'function') {
      // attachOnCollection injects each heart already in the right in/out state.
      if (!document.querySelector('.frcp-wishlist-grid-btn-wrapper')) {
        wishlist.attachOnCollection();
      }
      return;
    }
    if (tries++ < 40) setTimeout(attach, 250);
  })();
})();
